// 业绩路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/performance',
  component: Layout,
  children: [
    {
      path: 'profitlist',
      component: () => import('@/view/performance/profitlist'),
      name: '销售报表'
    },
    {
      path: 'recruitlist',
      component: () => import('@/view/performance/recruitlist'),
      name: '招新报表'
    },
    {
      path: 'customerNumber',
      component: () => import('@/view/performance/customerNumber'),
      name: '导购客户统计'
    },
    {
      path: 'UVReport',
      component: () => import('@/view/performance/UVReport'),
      name: '客户UV报表'
    }
  ]
}
